module.exports = __webpack_public_path__ + "static/media/company-liked-you-star.4d79845f.svg";